import React from "react";
import { ShieldCheck, Lock, Star, MapPin, Award } from "lucide-react";

/**
 * Trust strip — small horizontal band that anchors credibility above the fold.
 * Designed to be visually quiet (no loud colors) but reassuring. Sits between
 * the LiveActivityWidget and the videos section.
 */
export default function TrustStrip() {
    const items = [
        { icon: Award, label: "Veteran-led" },
        { icon: MapPin, label: "Made in Jacksonville" },
        { icon: ShieldCheck, label: "Member-only deals — verified businesses" },
        { icon: Lock, label: "Secure checkout · Privacy-first" },
        { icon: Star, label: "Founding VIP lifetime rate" },
    ];
    return (
        <section
            className="bg-[#FDFBF7] border-y border-black/5"
            data-testid="trust-strip"
            aria-label="Trust & safety highlights"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] sm:text-xs uppercase tracking-widest font-bold text-[#1A1D24]/65">
                    {items.map(({ icon: Icon, label }) => (
                        <li key={label} className="inline-flex items-center gap-1.5">
                            <Icon className="w-3.5 h-3.5 text-[#9B1B30]" />
                            {label}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
